import Model from "../base/model";

class Route extends Model {
  resourceName() {
    return "route";
  }

  fields() {
    return {
      origin: "",
      origin_state: "",
      origin_city: "",
      destiny: "",
      destiny_state: "",
      destiny_city: "",
      distance: ""
    };
  }

  async distanteOriginDestiny(data) {
    return this.request(
      "tms_external_api/route_origin_destiny",
      "POST",
      {},
      data
    );
  }

  async alterDistanteOriginDestiny(data) {
    return this.request(
      "tms_external_api/alter/route_origin_destiny/" + data.id,
      "POST",
      {},
      data
    );
  }
}
export default new Route();
